export default __webpack_public_path__ + "static/icons-512-748840abbf9fbe72d3154da528eed1e4.png";